import { useState, useCallback } from "react";

// Simple in-place toast hook + container (no external dep).
let listeners = [];
function emit(t) { listeners.forEach((l) => l(t)); }

export function toast(message, type = "info", ms = 3200) {
  emit({ id: Date.now() + Math.random(), message, type, ms });
}
toast.success = (m, ms) => toast(m, "success", ms);
toast.error   = (m, ms) => toast(m, "error", ms);
toast.info    = (m, ms) => toast(m, "info", ms);

export function ToastViewport() {
  const [items, setItems] = useState([]);
  const onAdd = useCallback((t) => {
    setItems((p) => [...p, t]);
    setTimeout(() => setItems((p) => p.filter((x) => x.id !== t.id)), t.ms);
  }, []);
  if (!listeners.includes(onAdd)) listeners = [onAdd];
  return (
    <div style={{ position: "fixed", bottom: 0, right: 0, display: "flex", flexDirection: "column", gap: 8, padding: 16, zIndex: 9999, pointerEvents: "none" }}>
      {items.map((t) => (
        <div key={t.id} className={`toast ${t.type}`} style={{ position: "relative", bottom: 0, right: 0, pointerEvents: "auto" }} data-testid={`toast-${t.type}`}>
          {t.message}
        </div>
      ))}
    </div>
  );
}
